// src/hooks/countries/useGetCountries.js
import { useQuery } from "@tanstack/react-query";
import { getAllCountries } from "../../api/apiCountries";

const QUERY_KEY = ["countries"];

const useGetCountries = (page = 1, perPage = 15, filters = {}) => {
  const {
    data,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: [...QUERY_KEY, page, perPage, filters],
    queryFn: () => getAllCountries(page, perPage, filters),
    keepPreviousData: true,
  });

  return {
    isLoading,
    error: isError ? error : null,
    countries: data?.data || data?.countries || [],
    meta: data?.data?.meta || null,
  };
};

export default useGetCountries;
